import createHistory from 'history/createBrowserHistory'

export default createHistory()


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/history/index.tsx